import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../styles/home.css';

// 瀵煎叆澶村儚鍙奓ogo鍥剧墖璧勬簮
import HeroLogo from '../assets/未来世界公司logobig.png';
import FukudaToshio from '../assets/福田敏男.png';
import KubotaNaoyuki from '../assets/久保田直行.png';
import XuChunshan from '../assets/许春山.png';
import manabe from '../assets/真鍋智章.png';
import yoshida from '../assets/吉田楓.png';
import matsumoto from '../assets/松本有.png';
import tanaka from '../assets/田中理.png';
import igarashi from '../assets/五十嵐章夫.png';
import Display_image_1 from '../assets/展示图片1.jpg';
import useRevealAnimation from '../hooks/useRevealAnimation';
import useDocumentTitle from '../hooks/useDocumentTitle';
import { fetchContentList } from './resources/contentHubApi';
import type { ContentEntry, SupportedLocale } from './resources/types';

const normalizeLanguage = (language?: string | null): SupportedLocale => {
    const normalizedLanguage = language?.toLowerCase() ?? '';

    if (normalizedLanguage.startsWith('zh')) {
        return 'zh';
    }

    if (normalizedLanguage.startsWith('ja')) {
        return 'ja';
    }

    return 'en';
};

const Home: React.FC = () => {
    const { t, i18n } = useTranslation();
    const heroRef = useRef<HTMLDivElement>(null);
    const pageRef = useRef<HTMLDivElement>(null);
    const [featuredNews, setFeaturedNews] = useState<ContentEntry[]>([]);

    const avatarMap: Record<string, string> = {
        fukuda: FukudaToshio,
        kubota: KubotaNaoyuki,
        xu: XuChunshan,
        manabe: manabe,
        yoshida: yoshida,
        matsumoto: matsumoto,
        tanaka: tanaka,
        igarashi: igarashi,
    };

    useEffect(() => {
        // 1. 榧犳爣璺熼殢鐗规晥閫昏緫
        const handleMouseMove = (e: MouseEvent) => {
            if (!heroRef.current) return;
            const { clientX, clientY } = e;
            const { innerWidth, innerHeight } = window;

            // 璁＄畻鍋忕Щ鐧惧垎姣?
            const xPct = (clientX / innerWidth) * 100;
            const yPct = (clientY / innerHeight) * 100;

            // 璁剧疆 CSS 鍙橀噺锛岄┍鍔ㄦ牱寮忓彉鍖?
            heroRef.current.style.setProperty('--mouse-x', `${xPct}%`);
            heroRef.current.style.setProperty('--mouse-y', `${yPct}%`);
        };

        window.addEventListener('mousemove', handleMouseMove);

        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
        };
    },[]);

    useRevealAnimation(pageRef);

    const locale = normalizeLanguage(i18n.resolvedLanguage || i18n.language);
    const pageTitle = useMemo(() => {
        if (locale === 'zh') return '未来世界';
        if (locale === 'ja') return 'フューチャーワールド';
        return 'Future World';
    }, [locale]);
    useDocumentTitle(pageTitle);

    useEffect(() => {
        let cancelled = false;

        const loadFeaturedNews = async () => {
            try {
                const result = await fetchContentList('news', {
                    page: 1,
                    pageSize: 6,
                    lang: locale,
                });

                if (cancelled) {
                    return;
                }

                setFeaturedNews(result.items.filter((item) => item.isPinned).slice(0, 3));
            } catch {
                if (!cancelled) {
                    setFeaturedNews([]);
                }
            }
        };

        void loadFeaturedNews();

        return () => {
            cancelled = true;
        };
    }, [locale]);

    const [leadNews, secondaryNews] = useMemo(
        () => [featuredNews[0] ?? null, featuredNews.slice(1, 3)],
        [featuredNews]
    );

    // 3. 澶勭悊骞虫粦婊氬姩鍒颁笅涓€鍖哄煙
    const handleExploreClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        const targetId = e.currentTarget.getAttribute('href')?.substring(1);
        if (targetId) {
            const targetElement = document.getElementById(targetId);
            if (targetElement) {
                targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }
    };

    const teamMembers = t('Home.about.teamMembers', { returnObjects: true }) as Array<{ name: string, imgKey: string }>;
    const serviceTags = t('Home.services.tags', { returnObjects: true }) as string[];
    const serviceHighlights = t('Home.services.highlights', { returnObjects: true }) as string[];
    return (
        <div className="home-page" ref={pageRef}>
            {/* Hero Section - 绉戝够浜や簰鏁堟灉 */}
            <section className="hero" ref={heroRef}>
                <div className="cyber-background">
                    <div className="grid-overlay"></div>
                    <div className="hero-energy hero-energy-right"></div>
                    <div className="moving-lines"></div>
                    <div className="interactive-glow"></div>
                    <div className="hero-vignette"></div>
                </div>

                <div className="hero-content reveal">
                    {/* Logo涓庝富鏍囬骞舵帓甯冨眬 */}
                    <div className="hero-title-wrapper">
                        <div className="hero-logo-panel">
                            <img src={HeroLogo} alt="Company Logo" className="hero-logo" />
                        </div>

                        <div className="hero-copy-block">
                            <h1 className="hero-title">
                                <span className="hero-title-line hero-title-line-primary">
                                    {t('Home.hero.title1')}
                                </span>
                                <span className="hero-title-line hero-title-line-secondary">
                                    {t('Home.hero.title2Prefix')}
                                    <span className="glitch-text" data-text={t('Home.hero.title2Highlight')}>
                                        {t('Home.hero.title2Highlight')}
                                    </span>
                                    {t('Home.hero.title2Suffix')}
                                </span>
                            </h1>

                            <div className="hero-btns">
                                <a href="#services" className="btn-modern" onClick={handleExploreClick}>
                                    <span>{t('Home.hero.btn')}</span>
                                    <div className="btn-glow"></div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="scroll-indicator">
                    <div className="mouse"></div>
                </div>
            </section>

            <section id="services" className="section-container">
                {/* Services Section */}
                <div className="reveal">
                    <div className="section-header" style={{ marginBottom: 30 }}>
                        <span className="section-subtitle">{t('Home.services.subtitle')}</span>
                        <h2 className="section-title">
                            {t('Home.services.titlePrefix')}<span style={{ color: 'var(--accent-red)' }}>{t('Home.services.titleHighlight')}</span>{t('Home.services.titleSuffix')}
                        </h2>
                    </div>
                    <div className="service-tags">
                        {serviceTags.map((tag, i) => (
                            <span className="tag" key={i}>{tag}</span>
                        ))}
                    </div>
                    <div className="service-intro-panel reveal delay-1">
                        <span className="service-kicker">{t('Home.services.kicker')}</span>
                        <h3 className="service-panel-title">{t('Home.services.slogan')}</h3>
                        <div className="service-highlight-list">
                            {serviceHighlights.map((item, i) => (
                                <div className="service-highlight-item" key={i}>{item}</div>
                            ))}
                        </div>
                    </div>
                    <div className="service-layout">
                        <div className="service-img-main">
                            <img
                                src={Display_image_1}
                                alt={t('Home.services.imgText')}
                                className="service-img"
                            />
                        </div>
                        <div className="service-cards">
                            <Link to="/services/china/enterprise/onestop" className="s-card reveal delay-1">
                                <div className="s-card-title">{t('Home.services.tob.title')} <span>{'->'}</span></div>
                                <p style={{ fontWeight: 'bold', marginBottom: 5 }}>{t('Home.services.tob.target')}</p>
                                <p style={{ fontSize: '0.9rem', color: 'var(--text-light)' }}>{t('Home.services.tob.desc')}</p>
                            </Link>
                            <Link to="/services/china/personal/digital" className="s-card reveal delay-2">
                                <div className="s-card-title">{t('Home.services.toc.title')} <span>{'->'}</span></div>
                                <p style={{ fontWeight: 'bold', marginBottom: 5 }}>{t('Home.services.toc.target')}</p>
                                <p style={{ fontSize: '0.9rem', color: 'var(--text-light)' }}>{t('Home.services.toc.desc')}</p>
                            </Link>
                        </div>
                    </div>
                </div>

                <div className="home-team-section reveal">
                    <Link to="/resources/core-people" className="home-team-header">
                        <span className="section-subtitle">{t('Home.about.subtitle')}</span>
                        <h3>{t('Home.about.teamTitle')}</h3>
                        <span className="home-team-cta">{t('Home.about.teamCta')}</span>
                    </Link>
                    <div className="team-grid">
                        {teamMembers.map((member, i) => {
                            const hasAvatar = !!avatarMap[member.imgKey];
                            return (
                                <Link to="/resources/core-people" className="team-member" key={i}>
                                    <div className={`team-avatar ${!hasAvatar ? 'img-placeholder' : ''}`} style={{ animationDelay: `-${i * 0.5}s` }}>
                                        {hasAvatar && (
                                            <img src={avatarMap[member.imgKey]} alt={member.name} />
                                        )}
                                    </div>
                                    <div className="team-name">{member.name}</div>
                                </Link>
                            );
                        })}
                    </div>
                </div>
            </section>

            {/*
            <section id="solutions" className="section-container">
                <div className="section-header reveal">
                    <span className="section-subtitle">{t('Home.solutions.subtitle')}</span>
                    <h2 className="section-title">{t('Home.solutions.title')}</h2>
                    <Link to="/ai" className="home-section-cta">
                        {t('Home.solutions.cta')}
                    </Link>
                </div>
                <div className="solution-grid">
                    <div className="ai-hr-card reveal delay-1">
                        <div className="ai-hr-img-box img-placeholder">
                            <img src={AiInterviewerImg} alt="AI Interviewer" />
                        </div>
                        <div className="ai-hr-text">
                            <h3>{t('Home.solutions.aiHr.title')}</h3>
                            <p>{t('Home.solutions.aiHr.p1')}</p>
                            <p>{t('Home.solutions.aiHr.p2')}</p>
                            <p>{t('Home.solutions.aiHr.p3')}</p>
                        </div>
                    </div>
                    <div className="solution-list reveal delay-2">
                        {solutionsList.map(item => (
                            <div className="sl-item" key={item.num}>
                                <div className="sl-num">{item.num}</div>
                                <div className="sl-content">
                                    <h4 style={{ fontSize: '1.2rem', marginBottom: 5 }}>{item.title}</h4>
                                    <p style={{ color: 'var(--text-light)', fontSize: '0.9rem' }}>{item.desc}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            */}

            {leadNews ? (
                <section id="home-news" className="section-container">
                    <div className="section-header reveal">
                        <span className="section-subtitle">{t('Home.news.subtitle')}</span>
                        <h2 className="section-title">{t('Home.news.title')}</h2>
                        <Link to="/resources/news" className="home-section-cta">
                            {t('Home.news.more')}
                        </Link>
                    </div>

                    <div className="home-news-showcase reveal delay-1">
                        <Link to={`/resources/news/${leadNews.slug}`} className="home-news-lead-card">
                            <div className="home-news-lead-media">
                                {leadNews.coverImageUrl ? (
                                    <img src={leadNews.coverImageUrl} alt={leadNews.title} />
                                ) : (
                                    <div className="home-news-media-placeholder">{t('Home.news.imgPlaceholder')}</div>
                                )}
                            </div>
                            <div className="home-news-lead-content">
                                <div className="home-news-meta-row">
                                    <span className="home-news-badge">{leadNews.badge}</span>
                                    <span className="home-news-date">{leadNews.date}</span>
                                </div>
                                <h3>{leadNews.title}</h3>
                                <p>{leadNews.summary}</p>
                                <span className="home-news-link">{t('Home.news.more')}</span>
                            </div>
                        </Link>

                        {secondaryNews.length > 0 ? (
                            <div className="home-news-side-list">
                                {secondaryNews.map((item) => (
                                    <Link key={item.id} to={`/resources/news/${item.slug}`} className="home-news-side-card">
                                        <div className="home-news-meta-row">
                                            <span className="home-news-badge">{item.badge}</span>
                                            <span className="home-news-date">{item.date}</span>
                                        </div>
                                        <h3>{item.title}</h3>
                                        <p>{item.summary}</p>
                                        <span className="home-news-link">{t('Home.news.more')}</span>
                                    </Link>
                                ))}
                            </div>
                        ) : null}
                    </div>
                </section>
            ) : null}

            {/* About Section */}
            <section id="about" className="section-container">
                <div className="section-header reveal">
                    <span className="section-subtitle">{t('Home.about.subtitle')}</span>
                    <h2 className="section-title">{t('Home.about.title')}</h2>
                    <Link to="/about" className="home-section-cta">
                        {t('Home.about.cta')}
                    </Link>
                </div>
                <div className="about-grid">
                    <div className="philosophy-box reveal delay-1">
                        <div className="phil-title">{t('Home.about.philosophy.title')}</div>
                        <div className="phil-subtext">{t('Home.about.philosophy.titleDesc')}</div>

                        <div className="phil-subtitle">
                            <span style={{ color: 'var(--accent-red)' }}>AI</span> = {t('Home.about.philosophy.subtitle')}
                        </div>
                        <div className="phil-subtext phil-subtext-last">{t('Home.about.philosophy.subtitleDesc')}</div>

                        <div className="phil-principles">
                            <p><strong>Speed:</strong> {t('Home.about.philosophy.speed')}</p>
                            <p><strong>Opportunity:</strong> {t('Home.about.philosophy.opportunity')}</p>
                            <p><strong>Link:</strong> {t('Home.about.philosophy.link')}</p>
                            <p><strong>Value:</strong> {t('Home.about.philosophy.value')}</p>
                            <p className="phil-principle-wide"><strong>Experience & Excellence:</strong> {t('Home.about.philosophy.experience')}</p>
                        </div>
                    </div>
                </div>
                <div className="mission-vision mission-vision-compact reveal delay-2" style={{ marginTop: 24 }}>
                    <div className="mv-card">
                        <span className="mv-tag">{t('Home.about.mission.tag')}</span>
                        <h3>{t('Home.about.mission.text')}</h3>
                    </div>
                    <div className="mv-card">
                        <span className="mv-tag">{t('Home.about.vision.tag')}</span>
                        <h3>{t('Home.about.vision.text')}</h3>
                    </div>
                </div>
            </section>

        </div>
    );
};

export default Home;

